import {
  callAPIInterface,
  maintenanceStatus,
  prepareTabDataInOrder,
  supportedTaprootAssets,
  withdrawConst,
} from "../components/constants";
import { resendVerificationMsg } from "../components/messages";
import {
  HIDE_TOAST_MESSAGE,
  SET_ACCOUNT_CURRENCY,
  SET_ACCOUNT_RESTRICTED_MODAL_DATA,
  SET_CURRENT_NAME,
  SET_DEFAULT_TAPROOT_CURRENCY,
  SET_DEFAULT_WALLET_CURRENCY,
  SET_LOGIN_DATA,
  SET_MAINTENANCE_FLAG,
  SET_MAINTENANCE_MODAL_OPEN,
  SET_REDIRECT_URL,
  SET_REGISTER_DATA,
  SET_SHOW_BTC_AMOUNT,
  SET_TRANSACTION_FILTER_DATA,
  SET_IS_HIDE_UNDER_MAINTENANCE_BAR,
  SHOW_TOAST_MESSAGE,
  SET_PAY_VIA_METHODS,
  SET_OPEN_APP_DETAIL_MODAL,
  SET_APP_DETAILS,
  SET_IS_OPEN_INSTALLED_APP_DIALOG,
  SET_MY_APPS_DATA,
  SET_COLLECTION_DATA,
  SET_CATEGORY_DATA,
  SET_APP_LIST,
  SET_NEW_ADDRESS_OBJ,
  SET_SEND_TO_CONTACT_DATA,
} from "./types";

export const setRegisterData = (data) => (dispatch) => {
  dispatch({
    type: SET_REGISTER_DATA,
    payload: data,
  });
};

export const setLoginData = (data) => (dispatch) => {
  dispatch({
    type: SET_LOGIN_DATA,
    payload: data,
  });
};

export const setRedirectUrl = (data) => (dispatch) => {
  dispatch({
    type: SET_REDIRECT_URL,
    payload: data,
  });
};

export const showToast = (data) => (dispatch) => {
  dispatch({
    type: SHOW_TOAST_MESSAGE,
    payload: data,
  });
};

export const hideToast = (data) => (dispatch) => {
  dispatch({
    type: HIDE_TOAST_MESSAGE,
    payload: data,
  });
};

export const setCurrentAccountName = (data) => async (dispatch) => {
  dispatch({
    type: SET_CURRENT_NAME,
    payload: data,
  });
};

export const setTaprootCurrency = (data) => (dispatch) => {
  dispatch({ type: SET_DEFAULT_TAPROOT_CURRENCY, payload: data });
};

export const setWalletCurrency = (data) => (dispatch) => {
  dispatch({ type: SET_DEFAULT_WALLET_CURRENCY, payload: data });
};

export const resendVerification = (data) => async (dispatch) => {
  try {
    await callAPIInterface(
      "POST",
      "/resend-verification-code",
      JSON.stringify(data)
    );
    dispatch(
      showToast({
        isToastOpen: true,
        toastMessage: resendVerificationMsg,
        toastVariant: "success",
      })
    );
  } catch (error) {}
};

export const setTransactionFilterData = (data) => (dispatch) => {
  dispatch({ type: SET_TRANSACTION_FILTER_DATA, payload: data });
};

export const setAccountRestrictedModalData = (data) => (dispatch) => {
  dispatch({
    type: SET_ACCOUNT_RESTRICTED_MODAL_DATA,
    payload: data,
  });
};

export const setAccountAsset =
  (afterLogin = false, redirectToDashboard = true) =>
  async (dispatch) => {
    return callAPIInterface("GET", `/assets-account?limit=20`)
      .then(async (response) => {
        if (response) {
          const supportedAssets = supportedTaprootAssets
            ?.map((asset) => response?.data?.find((d) => d?.uuid === asset))
            .filter(Boolean);

          const enabledMethods = supportedAssets?.map((asset) => ({
            ...asset,
            payment_method_details: asset?.payment_method_details?.filter(
              (method) =>
                method?.is_payment_method_enabled === true &&
                method?.supported_modules?.length
            ),
          }));

          if (afterLogin) {
            const supportedMethods = prepareTabDataInOrder(enabledMethods); //filter and sort methods which are supported in chrome wallet
            dispatch(setTaprootCurrency(supportedMethods[0])); //set the most weighted currency as taproot
          }

          const payViaMethods = response?.data?.reduce((acc, asset) => {
            // Ensure asset supports WITHDRAW
            if (!asset?.supported_modules?.includes(withdrawConst)) return acc;

            asset?.payment_method_details?.forEach((method) => {
              const methodName = method?.payment_method_name;
              const canAddPaymentMethod =
                method?.is_payment_method_enabled &&
                method?.supported_modules?.includes(withdrawConst);

              if (canAddPaymentMethod) {
                if (!acc[methodName]) acc[methodName] = [];

                // Prevent duplicates
                if (!acc[methodName].some((item) => item.name === asset.uuid)) {
                  acc[methodName].push({ name: asset.uuid });
                }
              }
            });
            return acc;
          }, {});
          dispatch(updatePayViaMethods(payViaMethods));
          dispatch(updateAccountAsset(enabledMethods));
          if (afterLogin) {
            if (redirectToDashboard) {
              dispatch(setRedirectUrl("/dashboard"));
              dispatch(setLoginData({ email: "" }));
            }
          }
        }
        return response;
      })
      .catch((_e) => false);
  };

export const updateAccountAsset = (data) => (dispatch) => {
  dispatch({
    type: SET_ACCOUNT_CURRENCY,
    payload: data,
  });
};

export const setShowBTCAmount = (data) => (dispatch) => {
  dispatch({ type: SET_SHOW_BTC_AMOUNT, payload: data });
};

export const setMaintenanceModalOpen = (data) => (dispatch) => {
  dispatch({ type: SET_MAINTENANCE_MODAL_OPEN, payload: data });
};

export const getMaintenanceStatus =
  ({ maintenanceLoader, afterLogin = false }) =>
  (dispatch) => {
    return callAPIInterface("GET", `/settings/maintenance/web_wallet`)
      .then(async (response) => {
        !afterLogin && maintenanceLoader(false);

        dispatch({ type: SET_MAINTENANCE_FLAG, payload: response });
        dispatch({
          type: SET_IS_HIDE_UNDER_MAINTENANCE_BAR,
          payload: !(
            response?.status?.toLowerCase() === maintenanceStatus?.scheduled
          ),
        });
      })
      .catch((_e) => {
        !afterLogin && maintenanceLoader(false);
        return false;
      });
  };

export const updatePayViaMethods = (data) => (dispatch) => {
  dispatch({
    type: SET_PAY_VIA_METHODS,
    payload: data,
  });
};

export const setNewAddressObj = (data) => (dispatch) => {
  dispatch({
    type: SET_NEW_ADDRESS_OBJ,
    payload: data,
  });
};

export const setSendToContactData = (data) => (dispatch) => {
  dispatch({
    type: SET_SEND_TO_CONTACT_DATA,
    payload: data,
  });
};

export const openAppDetailModal = (data) => (dispatch) => {
  dispatch({
    type: SET_OPEN_APP_DETAIL_MODAL,
    payload: data,
  });
};

export const setAppDetails = (data) => (dispatch) => {
  dispatch({
    type: SET_APP_DETAILS,
    payload: data,
  });
};

export const openInstalledAppDialog = (data) => (dispatch) => {
  dispatch({
    type: SET_IS_OPEN_INSTALLED_APP_DIALOG,
    payload: data,
  });
};

export const setMyAppsData = (data) => (dispatch) => {
  dispatch({
    type: SET_MY_APPS_DATA,
    payload: data,
  });
};

export const setCollectionData = (data) => (dispatch) => {
  dispatch({
    type: SET_COLLECTION_DATA,
    payload: data,
  });
};

export const setCategoryData = (data) => (dispatch) => {
  dispatch({
    type: SET_CATEGORY_DATA,
    payload: data,
  });
};

export const setAppList = (data) => (dispatch) => {
  dispatch({
    type: SET_APP_LIST,
    payload: data,
  });
};
